var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChasisIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 54,
    viewBox: "0 0 57 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_241_6650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8382 44.3686H3.46645L0 0H44.3718L47.8382 44.3686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5093 42.2123H5.45814L2.32837 2.16113H42.3796L45.5093 42.2123Z",
    fill: "#502BAC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.6873 46.0005H3.46644L0 1.63184H42.2208L45.6873 46.0005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M21.651 15.6443C23.6917 13.5223 23.4859 10.0133 21.1914 7.80683C18.8968 5.60031 15.3825 5.53182 13.3419 7.65384C11.3012 9.77586 11.507 13.2848 13.8016 15.4913C16.0961 17.6979 19.6104 17.7664 21.651 15.6443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.9538 41.1911L31.4975 25.9287L24.814 33.1796L19.6767 28.4163L7.90259 41.1911L17.4509 41.1661L17.3543 41.2721L47.9538 41.1911Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_241_6650",
    x: 0,
    y: 0,
    width: 56.9539,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_241_6650"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_241_6650",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChasisIco);
export default __webpack_public_path__ + "static/media/chasisIco.511d5ba3962f612883c64f695a05df1c.svg";
export { ForwardRef as ReactComponent };